/**
 *
 * @module purchaseActivationResult
 *
 */

import Check from 'check-types';
import InvalidArgumentException from '../exception/invalidArgumentException';

const {
    array,
    boolean
} = Check.assert;

/**
 *
 * @class PurchaseActivationResult
 * @desc Describes the result of a purchase activation attempt.
 *
 */
export default class PurchaseActivationResult {

    /**
     *
     * @param {Boolean} [refreshAccessToken=false]
     * @param {Boolean} [temporaryAccessGranted=false]
     * @param {Array<ErrorReason>} [errors=[]]
     * @param {Array<PurchaseActivation>} [purchases=[]]
     *
     */
    constructor(refreshAccessToken = false, temporaryAccessGranted = false, errors = [], purchases = []) {

        const errorMessage = {
            method: 'PurchaseActivationResult(refreshAccessToken, temporaryAccessGranted, errors, purchases)',
            get refreshAccessToken() {
                return `${this.method} refreshAccessToken should be a Boolean`;
            },
            get temporaryAccessGranted() {
                return `${this.method} temporaryAccessGranted should be a Boolean`;
            },
            get errors() {
                return `${this.method} errors should be an Array`;
            },
            get purchases() {
                return `${this.method} purchases should be an Array`;
            }
        };

        boolean(refreshAccessToken, errorMessage.refreshAccessToken, InvalidArgumentException);
        boolean(temporaryAccessGranted, errorMessage.temporaryAccessGranted, InvalidArgumentException);
        array(errors, errorMessage.errors, InvalidArgumentException);
        array(purchases, errorMessage.purchases, InvalidArgumentException);

        /**
         *
         * @access private
         * @type {Boolean}
         * @desc Gets an indicator that the access token should be refreshed before proceeding.
         *
         */
        this.refreshAccessToken = refreshAccessToken;

        /**
         *
         * @access private
         * @type {Boolean}
         * @desc Gets an indicator of whether temporary access was granted.
         *
         */
        this.temporaryAccessGranted = temporaryAccessGranted;

        /**
         *
         * @access private
         * @type {Array<ErrorReason>}
         * @desc Gets Errors responsible for why the request did not succeeded.
         *
         */
        this.errors = errors;

        /**
         *
         * @access private
         * @type {Array<PurchaseActivation>}
         * @desc Purchase information for all activated SKUs.
         *
         */
        this.purchases = purchases;

    }

}



// WEBPACK FOOTER //
// ./src/services/purchase/purchaseActivationResult.js